import { FiLoader } from 'react-icons/fi'
import styled, { keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledFormProps {
  $color: string;
  $border: boolean;
  theme: any;
  $themeCustom: any;
}
export const StyledForm = styled.form<StyledFormProps>`
  background-color: ${({ $color }) => $color};
  padding: ${pxToRem(40)} ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)};
  margin: ${pxToRem(20)};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: ${({ $border, theme, $themeCustom }) => ($border ? `3px solid ${$themeCustom && $themeCustom.details.buttons.color ? $themeCustom.details.buttons.color : theme.button_color}` : '')};
  border-right: ${({ $border, theme, $themeCustom }) => ($border ? `3px solid ${$themeCustom && $themeCustom.details.buttons.color ? $themeCustom.details.buttons.color : theme.button_color}` : '')};
    
  h2 {
    ${({ theme }) => theme.lock_font && `font-family: ${theme.lock_font}`};
    margin: 0 0 ${pxToRem(20)} 0;
    font-size: 36px;
    line-height: 36px;
  }

  h3 {
      ${({ theme }) => theme.lock_font && `font-family: ${theme.lock_font}`};
      margin: 0 0 ${pxToRem(20)} 0;
      font-size: 26px;
  }
`

interface StyledLabelProps {
  theme: any;
}
export const StyledLabel = styled.label<StyledLabelProps>`
  ${({ theme }) => theme.lock_font && `font-family: ${theme.lock_font}`};
  ${({ theme }) => theme.input_label_color && `color: ${theme.input_label_color}`};
  font-weight: ${({ theme }) => theme.lock_label_weight || '400'};
  ${({ theme }) => theme.input_label_uppercase && 'text-transform: uppercase'};
  text-align: left;
`

const getImage = (error, valid) => {
  if (error) return `url('/static/svg/icon/lock.svg'), url('/static/svg/icon/error.svg')`
  if (valid) return `url('/static/svg/icon/lock.svg'), url('/static/svg/icon/valid.svg')`
  return `url('/static/svg/icon/lock.svg')`
}

const getPosition = (error, valid) => {
  if (error) return `${pxToRem(10)}, right ${pxToRem(10)} bottom ${pxToRem(10)}`
  if (valid) return `${pxToRem(10)}, right ${pxToRem(10)} bottom ${pxToRem(8)}`
  return `${pxToRem(10)}`
}

const getSize = (error, valid) => {
  if (error) return `${pxToRem(20)}, ${pxToRem(25)}`
  if (valid) return `${pxToRem(20)}, ${pxToRem(25)} ${pxToRem(28)}`
  return `${pxToRem(20)}`
}

interface StyledInputProps {
  $error: boolean;
  $valid: boolean;
  theme: any;
}
export const StyledInput = styled.input<StyledInputProps>`
  padding: ${pxToRem(10)} ${pxToRem(40)} !important;
  background-repeat: no-repeat;
  background-image: ${({ $error, $valid }) => getImage($error, $valid)};
  background-size: ${({ $error, $valid }) => getSize($error, $valid)};
  background-position: ${({ $error, $valid }) => getPosition($error, $valid)};
  margin: ${pxToRem(20)} 0 0 0!important;
  width: 100%;
  border: ${({ theme }) => (theme.lock_input_border_none ? 'none' : `${pxToRem(1)} solid #ccc !important`)};
  ${({ theme }) => theme.input_shadow && `box-shadow: ${theme.input_shadow}`};
`

interface StyledGoInputProps {
  $error: boolean;
  $valid: boolean;
  theme: any;
}
export const StyledGoInput = styled.input<StyledGoInputProps>`
  padding: ${pxToRem(10)} ${pxToRem(40)} !important;
  background-repeat: no-repeat;
  background-image: ${({ $error, $valid }) => getImage($error, $valid)};
  background-size: ${({ $error, $valid }) => getSize($error, $valid)};
  background-position: ${({ $error, $valid }) => getPosition($error, $valid)};
  width: 100%;
  margin: 0 ${pxToRem(5)} 0 0!important;
  height: 48px;
  border: ${({ theme }) => (theme.lock_input_border_none ? 'none' : `${pxToRem(1)} solid #ccc !important`)};
  ${({ theme }) => theme.input_shadow && `box-shadow: ${theme.input_shadow}`};
`

export const StyledGoEmojiContainer = styled.div`
    display: flex;
    height: 48px;
`;

export const StyleButton = styled.div`
  div {
    margin: 10px auto auto;
  }
  button {
    border-radius: 8px;
  }
`;

export const StyleGoButton = styled.div`
  div {
    margin: 0;
  }
  button {
    height: 48px;
    width: 50px;
    border-radius: 8px;
    padding: 0;
  }
`;

export const StyleEmojiButton = styled.div`
    div {
        margin: 0;
    }
    button {
        height: 48px;
        width: 50px;
        border-radius: 8px;
        .ql-emojiblot {
            font-size: 20px;
        }
    }
`;

interface StyledSmallLabelProps {
  $state: string;
}
export const StyledSmallLabel = styled.p<StyledSmallLabelProps>`
  ${({ $state }) => $state === 'error' && 'color: #fe0045'};
  margin: ${pxToRem(10)};
`

const spin = keyframes`
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(360deg);
  }
`

export const StyledLoader = styled(FiLoader)`
  margin-right: ${pxToRem(10)};
  animation: ${spin} 3s linear infinite;
`